import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import ListItem from 'srcReact/components/common2/ListItem'
import Spinner from 'srcReact/components/common2/Spinner'
import { TextArea } from 'srcReact/components/common2/TextArea'
import { isEmpty } from 'srcReact/helpers/validator'
import styles from './styles.module.scss'
import { profileActions } from 'srcReact/MyProfile/action'
import Modal from 'srcReact/components/common2/Modal'
import ProfileChallengeText from 'srcReact/components/common2/ProfileChallengeText'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'
import { organizationActions } from 'srcReact/OrganizationPage'
import IconButton from 'srcReact/components/common2/IconButton'

function PromptListPopin({ isOpen, closeModal, promptToEdit, action, isChallenge = false, ctaPopup = '' }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [selectedPrompt, setSelectedPrompt] = useState(promptToEdit || null)
  const [addPromptTriggered, setAddPromptTriggered] = useState(false)
  const [additionalJustification, setAdditionalJustification] = useState({
    name: 'additionalJustification',
    value: selectedPrompt?.answer || '',
    hasError: false,
    errorMessage: '',
    isRequired: true
  })
  const {
    myProfile: {
      prompts,
      loading,
      profileData: { user }
    },
    common: { isNative }
  } = useSelector((state) => state)

  useEffect(() => {
    if (action === 'add') {
      dispatch(profileActions.getPromptList())
    }
  }, [action])

  useEffect(() => {
    if (addPromptTriggered && !user.prompts?.loading && user.prompts?.updated) {
      setAddPromptTriggered(false)
      callHeaderInfoForNative() //to update myprofile ctas
      closeModal()
    }
  }, [addPromptTriggered, user.prompts])

  const callHeaderInfoForNative = () => {
    if (isNative) {
      const organizationId = getCurrentOrgId()
      dispatch(organizationActions.getHeaderInfo(organizationId))
    }
  }

  const handleChangeAdditionalJustification = (e) => {
    const value = e.target.value
    setAdditionalJustification({
      ...additionalJustification,
      value: value,
      hasError: false,
      errorMessage: ''
    })
  }
  const handleSelectedPrompt = (prompt) => {
    const findSelectedPrompt = prompts.find((p) => p?.prompt === prompt)
    setSelectedPrompt(findSelectedPrompt)
  }
  const handleBlur = () => {}
  // const isValidatedFlag = (id_post, object_type, object_id, id_organization, id_flag_reason) => {
  //   if (id_post && object_type && object_id && id_organization && id_flag_reason) return true
  //   return false
  // }
  const handleSubmitPrompt = (e) => {
    e.preventDefault()
    if (isEmpty(additionalJustification.value)) {
      setAdditionalJustification({
        ...additionalJustification,
        hasError: true,
        errorMessage: t('moderationReport.flagPost.flagAdditionalRequired')
      })
      return false
    }
    setAddPromptTriggered(true)
    dispatch(profileActions.addPrompt(selectedPrompt?.id_prompt, additionalJustification?.value, ctaPopup))
  }
  const handleSaveAddPrompt = (e) => {
    e.preventDefault()
    if (isEmpty(additionalJustification.value)) {
      setAdditionalJustification({
        ...additionalJustification,
        hasError: true,
        errorMessage: t('moderationReport.flagPost.flagAdditionalRequired')
      })
      return false
    }
    setAddPromptTriggered(true)
    dispatch(profileActions.addPrompt(selectedPrompt?.id_prompt, additionalJustification?.value, ctaPopup))
    setTimeout(() => {
      dispatch(profileActions.getPromptList())
    }, 500)
    setTimeout(() => {
      setAdditionalJustification({
        ...additionalJustification,
        value: '',
        hasError: false,
        errorMessage: ''
      })
      setSelectedPrompt(null)
    }, 500)
  }

  const handleUpdatePrompt = (e) => {
    e.preventDefault()
    if (isEmpty(additionalJustification.value)) {
      setAdditionalJustification({
        ...additionalJustification,
        hasError: true,
        errorMessage: t('moderationReport.flagPost.flagAdditionalRequired')
      })
      return false
    }
    dispatch(profileActions.updatePrompt(selectedPrompt?.id_prompt_user, additionalJustification?.value, ctaPopup))
    setTimeout(() => {
      closeModal()
    }, 500)
  }

  return (
    <Modal
      nested
      isOpen={isOpen}
      handleClose={closeModal}
      closeOnDocumentClick={true}
      {...(action === 'add' && selectedPrompt !== null
        ? {
            showOptions: true,
            optionsChildren: (
              <IconButton iconName={'arrow-left24'} iconSize={'large32'} onClick={() => setSelectedPrompt(null)} />
            )
          }
        : {})}>
      {selectedPrompt ? (
        <React.Fragment>
          <h2 className={styles.promptPopupHeaderTitle}>{t('my_profile.myPrompts.newPromptPopup.title2')}</h2>
          <form className={styles.promptListForm}>
            <h3 className={styles.selectedPromptTitle}>{selectedPrompt.prompt}</h3>
            <TextArea
              rows={6}
              maxLength={250}
              isRequired={additionalJustification.isRequired}
              fieldInfo={additionalJustification}
              onChange={handleChangeAdditionalJustification}
              onBlur={handleBlur}
              customWrapperCss={styles.textboxFormWrapper}
              placeholder={t('my_profile.myPrompts.newPromptPopup.placeholder')}
            />
            <div className={styles.submitPrompt}>
              {action === 'edit' ? (
                <React.Fragment>
                  <Button style='tertiary' size='large' text={t('global.cancel')} handleClick={closeModal} />
                  <Button size='large' text={t('global.update')} handleClick={handleUpdatePrompt} />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <Button
                    style='tertiary'
                    size='large'
                    text={t('my_profile.myPrompts.newPromptPopup.saveAddPrompt')}
                    handleClick={handleSaveAddPrompt}
                  />
                  <Button
                    size='large'
                    handleClick={handleSubmitPrompt}
                    text={loading ? <Spinner isWhite={true} /> : t('global.save')}
                  />
                </React.Fragment>
              )}
            </div>
          </form>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <h2 className={styles.promptPopupHeaderTitle}>{t('my_profile.myPrompts.newPromptPopup.title1')}</h2>
          {isChallenge && user.prompts?.prompts?.length < appConstantSettings.CHALLENGE_PROMPT && (
            <ProfileChallengeText
              text={t('my_profile.info_block_edit.prompt.challenge', { count: appConstantSettings.CHALLENGE_PROMPT })}
            />
          )}
          <ListItem
            items={prompts?.map((f) => f.prompt)}
            activeItem={'0'}
            className={styles.listClassName}
            itemClassName={styles.listItemClassName}
            setActiveItem={handleSelectedPrompt}
            showIcon={true}
          />
        </React.Fragment>
      )}
    </Modal>
  )
}

export default PromptListPopin
